export type MenuBarButtonConfig = {
    soundOn: {
        hide?: boolean;
        action?: () => void;
    };
    soundOff: {
        hide?: boolean;
        action?: () => void;
    };
    close: {
        action?: () => void;
    };
    paytable: {
        active?: boolean;
        action?: () => void;
    };
    gameRules: {
        active?: boolean;
        action?: () => void;
    };
    gameHistory: {
        hide?: boolean;
        active?: boolean;
        action?: () => void;
    };
    logout: {
        hide?: boolean;
        action?: () => void;
    };
    support: {
        hide?: boolean;
        action?: () => void;
    };
    cashier: {
        hide?: boolean;
        action?: () => void;
    };
};

export interface IMenuBar {
    updateButtonPanel(config: MenuBarButtonConfig): void;
}
